import React, { useState } from 'react';
import NavSubBar from '../NavBarElementsDropdown/NavSubBar';
import EnSavoirPlus from '../NavBarElementsDropdown/EnSavoirPlus';
import { Button, Menu, MenuHandler } from '@material-tailwind/react';
import { ChevronDown } from 'lucide-react';
import { Bars3Icon } from '@heroicons/react/24/outline';

const menuItems = [
    { name: 'En savoir plus' },
];

function NavBarHomeDark() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <nav className="fixed top-0 left-0 w-full right-0 z-[100] px-2 items-center bg-dark-1 shadow-md">
            <div className="w-full h-[70px] md:h-[92px] flex items-center justify-between">
                <div className="flex items-center">
                    <a href="/">
                        {/* Logo pour le mode dark */}
                        <img
                            src="/general/Logo NextMaker.png"
                            alt="logo"
                            className="h-[50px] block"
                        />
                    </a>
                </div>

                <NavSubBar textColor='text-white' />

                <div className="flex items-center gap-4">
                    {menuItems.map((item) => (
                        <Menu key={item.name} placement={isMobileMenuOpen ? "bottom-start" : "bottom-start"}>
                            <MenuHandler>
                                <Button
                                    variant="text"
                                    className={`flex items-center text-sm text-white hover:text-purple-1
                            ${isMobileMenuOpen ? 'justify-between w-full py-2' : 'px-1'}`}
                                >
                                    <a className='font-light text-[15px] dark:hover:text-purple-300' href={item.link}>{item.name}</a>
                                    {(item.name === 'En savoir plus') && (
                                        isMobileMenuOpen ? (
                                            <ChevronDown size={20} className="ml-2 transition-transform duration-200 group-hover:rotate-180" />
                                        ) : (
                                            <ChevronDown size={20} className="transition-transform duration-200 group-hover:rotate-180" />
                                        )
                                    )}
                                </Button>
                            </MenuHandler>
                            <EnSavoirPlus mobile={isMobileMenuOpen} />
                        </Menu>
                    ))}
                    <a href="https://app.gonextmaker.com/auth/signup">
                        <button className="h-[50px] px-6 md:px-[30px] hover:bg-dark-1 border-2 border-dark-1
                    rounded-xl font-medium hover:text-white bg-white text-dark-1 transition-colors hover:border-white">
                            Rejoindre
                        </button>
                    </a>
                </div>
                {/* Menu mobile - Hamburger icon */}
                <div className="md:hidden flex items-center gap-3">
                    <button
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        className="p-2 text-dark-1 dark:text-white"
                    >
                        {isMobileMenuOpen ? (
                            <XMarkIcon className="h-6 w-6" />
                        ) : (
                            <Bars3Icon className="h-6 w-6" />
                        )}
                    </button>
                </div>
            </div>

            {/* Menu mobile dépliant */}
            {isMobileMenuOpen && (
                <div className="md:hidden bg-white dark:bg-dark-2 border-t border-gray-200 dark:border-gray-700 py-4 px-4">
                    <div className="flex flex-col space-y-4">
                        <div className="py-2">
                            <NavSubBar
                                textColor="text-dark-1 dark:text-white"
                                mobile={true}
                                orientation="vertical"
                            />
                        </div>

                        <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
                            {menuItems.map((item) => (
                                <Menu key={item.name} placement={isMobileMenuOpen ? "bottom-start" : "bottom-start"}>
                                    <MenuHandler>
                                        <Button
                                            variant="text"
                                            className={`flex items-center text-sm text-dark-1 dark:text-white hover:text-purple-1
                            ${isMobileMenuOpen ? 'justify-between w-full py-2' : 'px-1'}`}
                                        >
                                            <a className='font-light text-[12px] dark:hover:text-purple-300' href={item.link}>{item.name}</a>
                                            {(item.name === 'En savoir plus') && (
                                                isMobileMenuOpen ? (
                                                    <ChevronDown size={20} className="ml-2 transition-transform duration-200 group-hover:rotate-180" />
                                                ) : (
                                                    <ChevronDown size={20} className="transition-transform duration-200 group-hover:rotate-180" />
                                                )
                                            )}
                                        </Button>
                                    </MenuHandler>
                                    <EnSavoirPlus mobile={isMobileMenuOpen} />
                                </Menu>
                            ))}
                            <a
                                href="https://app.gonextmaker.com/auth/signup"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                <button className="w-full mt-2 h-[44px] bg-purple-1 border-2 border-purple-1
                                rounded-full font-medium text-white hover:bg-transparent hover:text-purple-1 dark:hover:text-purple-300 transition-colors">
                                    Rejoindre
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            )}

        </nav>
    );
}

export default NavBarHomeDark